import GroupsOnboarding from './ModernGroup';

export default GroupsOnboarding;
